import { computed, ref } from "vue";
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";

const { selected_plan } = SelectedPlan();
const { plan_brand } = Utilities();

const brand = computed(() => plan_brand(selected_plan.value));

const show_four_change = computed(() => brand.value === '4Change Energy');
const show_constellation = computed(() => brand.value === 'Constellation');
const show_payless = computed(() => brand.value === 'Payless Power');
const show_just_energy = computed(() => ['Just Energy', 'Amigo Energy', 'Tara Energy'].includes(brand.value));
const show_next_era = computed(() => ['Gexa Energy', 'Frontier Utilities'].includes(brand.value));
const show_flagship = computed(()=> ['Flagship Power'].includes(brand.value));
const show_standard = computed(() => !show_four_change.value && !show_constellation.value && !show_just_energy.value && !show_next_era.value && !show_payless.value && !show_flagship.value);

const four_change_agreed = ref(false);
const constellation_agreed = ref(false);
const payless_agreed = ref(false);
const just_energy_agreed = ref(false);
const next_era_agreed = ref(false);
const flagship_agreed = ref(false);
const standard_agreed = ref(false);

const clear_authorizations = function () {
    credit_check_authorized.value = false;
    four_change_agreed.value = false;
    constellation_agreed.value = false;
    payless_agreed.value = false;
    just_energy_agreed.value = false;
    next_era_agreed.value = false;
    flagship_agreed.value = false;
    standard_agreed.value = false;
}

const credit_check_authorized = ref(false);

const all_agreed = computed(() => {
    return credit_check_authorized.value
        && (!show_four_change.value || four_change_agreed.value)
        && (!show_constellation.value || constellation_agreed.value)
        && (!show_payless.value || payless_agreed.value)
        && (!show_just_energy.value || just_energy_agreed.value)
        && (!show_next_era.value || next_era_agreed.value)
        && (!show_flagship.value || flagship_agreed.value)
        && (!show_standard.value || standard_agreed.value)
})

export default () => {
    return {
        show_four_change,
        show_constellation,
        show_payless,
        show_just_energy,
        show_next_era,
        show_flagship,
        show_standard,
        four_change_agreed,
        constellation_agreed,
        payless_agreed,
        just_energy_agreed,
        next_era_agreed,
        flagship_agreed,
        standard_agreed,
        all_agreed,
        credit_check_authorized,
        clear_authorizations
    }
}
